/**
 * Active player store — which save slot is currently being played.
 *
 * Persisted in localStorage so reloads return to the same save.
 */

import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type PlayerStoreState = {
  activePlayerId: number | null;
  setActivePlayer: (id: number | null) => void;
  clearActivePlayer: () => void;
};

export const usePlayerStore = create<PlayerStoreState>()(
  persist(
    (set) => ({
      activePlayerId: null,
      setActivePlayer: (id) => set({ activePlayerId: id }),
      clearActivePlayer: () => set({ activePlayerId: null }),
    }),
    {
      name: "rentier.activePlayer",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
